import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

import { ProjectPickerModule } from '../project-picker/project-picker.module';
import { ProjectsPickerComponent } from './projects-picker.component';

@NgModule({
    imports: [
        ProjectPickerModule,
        CommonModule,
        MatChipsModule,
        MatIconModule,
        ReactiveFormsModule
    ],
    declarations: [
        ProjectsPickerComponent
    ],
    exports: [
        ProjectsPickerComponent
    ]
})
export class ProjectsPickerModule {
}
